import { render, staticRenderFns } from "./ButtonSet.vue?vue&type=template&id=50efbfa2&scoped=true&"
import script from "./ButtonSet.vue?vue&type=script&lang=js&"
export * from "./ButtonSet.vue?vue&type=script&lang=js&"
import style0 from "./ButtonSet.vue?vue&type=style&index=0&id=50efbfa2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50efbfa2",
  null
  
)

export default component.exports